/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DistributionTypeEnum,
    DistributionTypeEnumFromJSON,
    DistributionTypeEnumFromJSONTyped,
    DistributionTypeEnumToJSON,
} from './DistributionTypeEnum';
import {
    ExchangeEntity,
    ExchangeEntityFromJSON,
    ExchangeEntityFromJSONTyped,
    ExchangeEntityToJSON,
} from './ExchangeEntity';
import {
    SymbolFundamentalDataHighlightsEntity,
    SymbolFundamentalDataHighlightsEntityFromJSON,
    SymbolFundamentalDataHighlightsEntityFromJSONTyped,
    SymbolFundamentalDataHighlightsEntityToJSON,
} from './SymbolFundamentalDataHighlightsEntity';
import {
    SymbolTypeEnum,
    SymbolTypeEnumFromJSON,
    SymbolTypeEnumFromJSONTyped,
    SymbolTypeEnumToJSON,
} from './SymbolTypeEnum';
import {
    WatchlistEntity,
    WatchlistEntityFromJSON,
    WatchlistEntityFromJSONTyped,
    WatchlistEntityToJSON,
} from './WatchlistEntity';

/**
 * 
 * @export
 * @interface SymbolEntity
 */
export interface SymbolEntity {
    /**
     * 
     * @type {SymbolTypeEnum}
     * @memberof SymbolEntity
     */
    type: SymbolTypeEnum | null;
    /**
     * 
     * @type {DistributionTypeEnum}
     * @memberof SymbolEntity
     */
    distributionType: DistributionTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    id: string;
    /**
     * 
     * @type {ExchangeEntity}
     * @memberof SymbolEntity
     */
    exchange: ExchangeEntity;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    exchangeId: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    quote: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    iexId: string | null;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    isin: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    figi: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SymbolEntity
     */
    hasDividendHistory: boolean;
    /**
     * 
     * @type {SymbolFundamentalDataHighlightsEntity}
     * @memberof SymbolEntity
     */
    fundamentalDataHighlights: SymbolFundamentalDataHighlightsEntity;
    /**
     * 
     * @type {Date}
     * @memberof SymbolEntity
     */
    latestHistoryUpdateDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SymbolEntity
     */
    latestDividendsUpdateDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SymbolEntity
     */
    latestSplitsUpdateDate?: Date;
    /**
     * 
     * @type {Array<WatchlistEntity>}
     * @memberof SymbolEntity
     */
    watchlists: Array<WatchlistEntity>;
    /**
     * 
     * @type {string}
     * @memberof SymbolEntity
     */
    referenceSymbolId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SymbolEntity
     */
    isActive: boolean;
}

export function SymbolEntityFromJSON(json: any): SymbolEntity {
    return SymbolEntityFromJSONTyped(json, false);
}

export function SymbolEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': SymbolTypeEnumFromJSON(json['type']),
        'distributionType': DistributionTypeEnumFromJSON(json['distributionType']),
        'id': json['id'],
        'exchange': ExchangeEntityFromJSON(json['exchange']),
        'exchangeId': json['exchangeId'],
        'symbol': json['symbol'],
        'name': json['name'],
        'currency': json['currency'],
        'quote': json['quote'],
        'iexId': json['iexId'],
        'isin': json['isin'],
        'figi': json['figi'],
        'hasDividendHistory': json['hasDividendHistory'],
        'fundamentalDataHighlights': SymbolFundamentalDataHighlightsEntityFromJSON(json['fundamentalDataHighlights']),
        'latestHistoryUpdateDate': !exists(json, 'latestHistoryUpdateDate') ? undefined : (new Date(json['latestHistoryUpdateDate'])),
        'latestDividendsUpdateDate': !exists(json, 'latestDividendsUpdateDate') ? undefined : (new Date(json['latestDividendsUpdateDate'])),
        'latestSplitsUpdateDate': !exists(json, 'latestSplitsUpdateDate') ? undefined : (new Date(json['latestSplitsUpdateDate'])),
        'watchlists': ((json['watchlists'] as Array<any>).map(WatchlistEntityFromJSON)),
        'referenceSymbolId': !exists(json, 'referenceSymbolId') ? undefined : json['referenceSymbolId'],
        'isActive': json['isActive'],
    };
}

export function SymbolEntityToJSON(value?: SymbolEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': SymbolTypeEnumToJSON(value.type),
        'distributionType': DistributionTypeEnumToJSON(value.distributionType),
        'id': value.id,
        'exchange': ExchangeEntityToJSON(value.exchange),
        'exchangeId': value.exchangeId,
        'symbol': value.symbol,
        'name': value.name,
        'currency': value.currency,
        'quote': value.quote,
        'iexId': value.iexId,
        'isin': value.isin,
        'figi': value.figi,
        'hasDividendHistory': value.hasDividendHistory,
        'fundamentalDataHighlights': SymbolFundamentalDataHighlightsEntityToJSON(value.fundamentalDataHighlights),
        'latestHistoryUpdateDate': value.latestHistoryUpdateDate === undefined ? undefined : (value.latestHistoryUpdateDate.toISOString()),
        'latestDividendsUpdateDate': value.latestDividendsUpdateDate === undefined ? undefined : (value.latestDividendsUpdateDate.toISOString()),
        'latestSplitsUpdateDate': value.latestSplitsUpdateDate === undefined ? undefined : (value.latestSplitsUpdateDate.toISOString()),
        'watchlists': ((value.watchlists as Array<any>).map(WatchlistEntityToJSON)),
        'referenceSymbolId': value.referenceSymbolId,
        'isActive': value.isActive,
    };
}

